
export const fireBaseApi =  {
  apiKey: "AIzaSyDABWAg6OhVnHp9ps3U14jCw3HtKICY7jA",
  authDomain: "my-app-books.firebaseapp.com",
  databaseURL: "https://my-app-books.firebaseio.com",
  projectId: "my-app-books",
  storageBucket: "my-app-books.appspot.com",
  messagingSenderId: "380994424973",
  appId: "1:380994424973:web:899acb97bcd6d5de9d92c4"
};